import {createVuetify} from 'vuetify';
import {fr} from 'vuetify/locale';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import {colors} from '@/theme/colors';

/**
 * Custom theme used to override some vuetify colors with tailwind colors
 * @type {{dark: boolean, colors: {secondary: string, orange: string, gray: string, error: string, accent: string, primary: string}}}
 */
const customTheme = {
    dark: false,
    colors: {
        primary: colors.primary.DEFAULT,
        secondary: colors.secondary.DEFAULT,
        gray: colors.gray.DEFAULT,
        accent: '#8c9eff',
        error: '#b71c1c',
        orange: colors.orange.DEFAULT,
    }
};

export default createVuetify({
    components: {
        ...components,
    },
    directives,
    theme: {
        defaultTheme: 'customTheme',
        themes: {
            customTheme,
        },
    },
    locale: {
        messages: {fr}
    }
});
